module.exports = __webpack_public_path__ + "static/media/gn.c1e0576c.svg";